import authMixin from '@/mixins/auth-mixin'

export default {
  mixins: [
    authMixin
  ],

  data () {
    return {
      //
    }
  },

  computed: {
    isUserAffiliated () {
      return this.isUserLoggedIn &&
        this.userLoggedIn.affiliate &&
        this.userLoggedIn.affiliate.is_active === true &&
        this.userLoggedIn.affiliate.is_expired === false
    }
  },

  mounted () {
    //
  },

  methods: {
    //
  }
}
